var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3397 31.7536C26.3469 35.4756 20.6793 35.4756 17.6865 31.7536L2.53628 12.9113C-1.39742 8.01902 2.08522 0.75 8.36285 0.75H38.6633C44.941 0.75 48.4236 8.01903 44.4899 12.9113L29.3397 31.7536Z",
    fill: "#55D7E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon1);
export default __webpack_public_path__ + "static/media/polygon-1.99839bbf870dd923c076fd8aa569a699.svg";
export { ForwardRef as ReactComponent };